import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";

const API_URL = `/services`;

const allServices = async () => {
  try {
    const response = await api.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des services :', error);
    handleHttpError(error, "Impossible de charger la liste des services.");
    return [];
  }
};

export const allServicesByDirections = async (directionId) => {
  const url = `${API_URL}/direction/${directionId}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des services par direction :', error);
    handleHttpError(error, "Échec de la récupération des services associés à la direction.");
    return [];
  }
};

const saveServices = async (servicesData) => {
  try {
    const response = await api.post(API_URL, servicesData);

    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement du service :', error);
    handleHttpError(error, "Impossible d'enregistrer le service.");
    throw error;
  }
};

export const deleteServices = async (servicesId) => {
  const url = `${API_URL}/${servicesId}`;
  try {
    await api.delete(url);
  } catch (error) {
    console.error('Erreur lors de la suppression du service :', error);
    handleHttpError(error, "Échec de la suppression du service.");
    throw error;
  }
};

export const getIdServices = async (servicesId) => {
  const url = `${API_URL}/${servicesId}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération du service :', error);
    handleHttpError(error, "Impossible de récupérer les informations du service.");
    throw error;
  }
};

export const updateServices = async (servicesId, servicesData) => {
  const url = `${API_URL}/${servicesId}`;
  try {
    const response = await api.put(url, servicesData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour du service :', error);
    handleHttpError(error, "Impossible de mettre à jour le service.");
    throw error;
  }
};

export const updateDisabledService = async (serviceId, serviceData) => {
  const url = `${API_URL}/disabled/${serviceId}`;
  try {
    const response = await api.put(url, serviceData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la désactivation du service :', error);
    handleHttpError(error, "Impossible de désactiver le service.");
    throw error;
  }
};

export { saveServices, allServices };
